var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover-box"},[_c('a',{attrs:{"href":_vm.buttonHref}},[_c('b-img',{attrs:{"fluid":"","src":_vm.img}}),_c('span',{staticClass:"provider-name"},[_vm._v(_vm._s(_vm.providerName))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }